export default "__VITE_ASSET__jacp33Xx__"